
const initialState = {
    dealData:[]
  }

export const ACTION_TYPES = {
    SET_DEAL_DATA: 'homeactivity/SET_DEAL_DATA',
};
  

  
  // Use the initialState as a default value
 const HomeActivityReducer = (state = initialState, action) => {
    // The reducer normally looks at the action type field to decide what happens
    switch (action.type) {
        case ACTION_TYPES.SET_DEAL_DATA:
            return {
                ...state,
                dealData:action.payload
            }
      default:
        // If this reducer doesn't recognize the action type, or doesn't
        // care about this specific action, return the existing state unchanged
        return state
    }
  }

  export default HomeActivityReducer;